import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcLocationGroupsInputComponent } from './fc-location-groups-input.component';


@NgModule({
  declarations: [
    FcLocationGroupsInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcLocationGroupsInputComponent
  ]
})
export class FcLocationGroupsInputModule {}
